import { render, staticRenderFns } from "./ChatConfirmMore.vue?vue&type=template&id=5ab8bcb2&scoped=true"
import script from "./ChatConfirmMore.vue?vue&type=script&lang=js"
export * from "./ChatConfirmMore.vue?vue&type=script&lang=js"
import style0 from "./ChatConfirmMore.vue?vue&type=style&index=0&id=5ab8bcb2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ab8bcb2",
  null
  
)

export default component.exports